import { routes as gedCategoria } from './gedcategoria';
import { routes as gedConfiguracao } from './gedconfiguracao';
import { routes as gedDocumento } from './geddocumento';
import { routes as gedEscrituracao } from './gedescrituracao';
import { routes as gedEscola } from './gedescola';
import { routes as gedEstudante } from './gedestudante';
import { routes as gedGrupo } from './gedgrupo';
import { routes as gedServidor } from './gedservidor';
import { routes as gedTermoControlado } from './gedtermocontrolado';
import { routes as gedTipoDado } from './gedtipodado';

export default [
  {
    path: '/ged',
    name: 'GED',
    description: 'GED',
    icon: 'uil-archive-alt',
    goesToMenu: true,
    children: [
      ...gedCategoria,
      ...gedGrupo,
      ...gedDocumento,
      ...gedEscrituracao,
      ...gedEscola,
      ...gedEstudante,
      ...gedServidor,
      ...gedTermoControlado,
      ...gedConfiguracao,
      ...gedTipoDado,
    ],
  },
];
